export default "January 1, 2023";